// extracted by mini-css-extract-plugin
export default {"center":"center__wKdjm","wrapper":"wrapper__fZhi6"};